
import {throwError as observableThrowError, forkJoin as observableForkJoin, of as observableOf,  Observable, Observer } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import { Http } from '@angular/http';
import * as moment from 'moment';

import 'rxjs/Rx';

// configuracao
import { ConfigService } from '../config/config.service';
import { ItemsUtilService } from '../utils/items.util.service';

// mock
import { MockService } from './mock.service';
import { DriverService } from './driver.service';
import { AssetService } from './asset.service';

import { Alarm, AlarmDto, Asset, RoadDefendData, Driver, User, AlarmType, Customer, WorkspaceProfileData, FilterAlarms, Equipament, Device}  from '../models';
import { EquipamentType } from '../enum/equipament.type.enum';
import { Status } from '../enum/status.enum';
import { Workspace, AccessControlDesc, customerChildsPermissions } from '../models/workspace.data.entity';
import { CustomerChild } from '../models/customerChild.entity';
import { TranslateJsonService } from './translate-json.service';
import { RiskRating } from '../models/risk-rating.entity';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';
import { InfractionDto } from '../models/infraction.dto';
import { Infraction } from '../models/infraction.entity';

@Injectable()
export class DataService {
  public userName = environment.userNameCreare;

  private roadDefendData : RoadDefendData = new RoadDefendData();
  private _baseUrl: string = '';

  public notFoundImage = environment.notFoundImg;


  
  public alarmTypesNumber = [
    {label: this.translateJsonService.getAlarmTypesTranslate(2), value: 2, icon: 'assets/images/sleep.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(6), value: 6, icon: 'assets/images/sleep.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(7), value: 7, icon: 'assets/images/yawning.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(1), value: 1, icon: 'assets/images/ause.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(9), value: 9, icon: 'assets/images/cigarette.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(4), value: 4, icon: 'assets/images/cell.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(8), value: 8, icon: 'assets/images/camCovered.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(3), value: 3, icon: 'assets/images/faceSide.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(5), value: 5, icon: 'assets/images/exchangeDriver.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(10), value: 10, icon: 'assets/images/impact.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(11), value: 11, icon: 'assets/images/pedestrian.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(12), value: 12, icon: 'assets/images/tail_gating.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(13), value: 13, icon: 'assets/images/swerving.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(14), value: 14, icon: 'assets/images/over_speed.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(15), value: 15, icon: 'assets/images/no_seatbelt.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(16), value: 16, icon: 'assets/images/fall.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(17), value: 17, icon: 'assets/images/low_spo2.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(22), value: 22, icon: 'assets/images/bradycardia.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(23), value: 23, icon: 'assets/images/tachycardia.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(24), value: 24, icon: 'assets/images/rider-detec.png'},
    { label: this.translateJsonService.getAlarmTypesTranslate(25), value: 25, icon: 'assets/images/drowsiness-confirmation.png'},
    { label: this.translateJsonService.getAlarmTypesTranslate(26), value: 26, icon: 'assets/images/drowsiness-confirmation.png' },
    { label: this.translateJsonService.getAlarmTypesTranslate(27), value: 27, icon: 'assets/images/speed.png' },
    { label: this.translateJsonService.getAlarmTypesTranslate(28), value: 28, icon: 'assets/images/sharp-turn.png'},
    { label: this.translateJsonService.getAlarmTypesTranslate(29), value: 29, icon: 'assets/images/hard-braking.png'},
    { label: this.translateJsonService.getAlarmTypesTranslate(30), value: 30, icon: 'assets/images/hard-acceleration.png'},
    {label: this.translateJsonService.getAlarmTypesTranslate(31), value: 31, icon: 'assets/images/stop-sign.png'},
    { label: this.translateJsonService.getAlarmTypesTranslate(32), value: 32, icon: 'assets/images/accumulated-drowsiness.png'},
    { label: this.translateJsonService.getAlarmTypesTranslate(33), value: 33, icon: 'assets/images/invalid-alarm.png'},
    { label: this.translateJsonService.getAlarmTypesTranslate(45), value: 45, icon: 'assets/images/incompatible-glasses.svg'},
    { label: this.translateJsonService.getAlarmTypesTranslate(46), value: 46, icon: 'assets/images/speed.png'},
    { label: this.translateJsonService.getAlarmTypesTranslate(47), value: 47, icon: 'assets/images/tail_gating.png'},
    { label: this.translateJsonService.getAlarmTypesTranslate(162), value: 162, icon: 'assets/images/calibration-error.svg'}
  ]
  public  returnEvaluationStatus(aiEvaluationStatus: string): {label: string; value: string; icon: string} | undefined  {
      return this.aiEvaluationStatusIcon.find(value => value.value === aiEvaluationStatus);
  }
  public shouldShowAiEvaluationIcon(aiEvaluationStatus: string): boolean {
      return aiEvaluationStatus === 'CONFIRMED'
          || aiEvaluationStatus === 'INCONCLUSIVE'
          || aiEvaluationStatus === 'CONFIRMED_SECONDARY';
  }
  public aiEvaluationStatusIcon = [
        {label: "aiEvaluationConfirmed" , value: "CONFIRMED", icon: 'assets/images/iaEvaluationConfirmed.png'},
        {label: "aiEvaluationInconclusive", value: "INCONCLUSIVE", icon: 'assets/images/iaEvaluationInconclusive.png'},
        {label: "aiEvaluationConfirmedSecondary", value: "CONFIRMED_SECONDARY", icon: 'assets/images/iaEvaluationFalse.png'},
        {label: "aiEvaluationFalse", value: "FALSE", icon: 'assets/images/iaEvaluationFalse.png'}

  ]

    public returnHumanEvaluationStatus(humanEvaluationStatus: string): {label: string; value: string; icon: string} | undefined  {
        return this.humanEvaluationStatusIcon.find(value => value.value === humanEvaluationStatus);
    }
    public humanEvaluationStatusIcon = [
        {label: "humanEvaluationInvalid" , value: "INVALID", icon: 'assets/images/humanEvaluationInvalid.png'},
        {label: "humanEvaluationValid" , value: "VALID", icon: 'assets/images/humanEvaluationValid.png'},
        {label: "humanNotEvaluation" , value: "NOTEVALUATION", icon: 'assets/images/humanNotEvaluation.png'},
        {label: "humanEvaluationFinish" , value: "FINISH", icon: 'assets/images/humanEvaluationFinish.png'}

    ]

  public infractionTypesNumber =  [
    {label: this.translateJsonService.getAlarmTypesTranslate(3003), value: 3003, icon: ''},
    {label: this.translateJsonService.getAlarmTypesTranslate(3004), value: 3004, icon: ''},
    {label: this.translateJsonService.getAlarmTypesTranslate(3006), value: 3006, icon: ''},
    {label: this.translateJsonService.getAlarmTypesTranslate(3007), value: 3007, icon: ''},
    {label: this.translateJsonService.getAlarmTypesTranslate(3009), value: 3009, icon: ''},
    {label: this.translateJsonService.getAlarmTypesTranslate(3010), value: 3010, icon: ''},
    {label: this.translateJsonService.getAlarmTypesTranslate(3011), value: 3011, icon: ''},
    {label: this.translateJsonService.getAlarmTypesTranslate(3012), value: 3012, icon: ''},
    {label: this.translateJsonService.getAlarmTypesTranslate(3013), value: 3013, icon: ''},
  ]

  constructor(
    private configService: ConfigService,
      private http: Http,
      private itemsService: ItemsUtilService,
      private mockService: MockService,
      private driverService: DriverService,
      private assetService: AssetService,
      private translateJsonService: TranslateJsonService,
      private router: Router
    )
  {
      this._baseUrl = configService.getApiURI();
  }

  public registerRoadDefendData(data: RoadDefendData): RoadDefendData {
    this.roadDefendData = data;
    return this.roadDefendData;
  }

  public registerRiskRating(riskRatingList : RiskRating[]): RiskRating[] {
    let riskRatingListSalved = this.roadDefendData.riskRatingList;

    riskRatingList.forEach((rr) => {
      if(!riskRatingListSalved.includes(rr)){
        riskRatingListSalved.push(rr);
      }
    })

    return riskRatingListSalved;
  }

  public getRiskRating(): RiskRating[] {
    return this.roadDefendData.riskRatingList;
  }

 // *****************************************************************
 // alarmes
 public getAlarmsDiff(_alarms: Alarm[]): Alarm[] {
   let _alarmList: Alarm[] = [];
    _alarms.forEach((alarm) => {
        if (!this.roadDefendData.alarmList.find(_alarm_ => _alarm_ && _alarm_.id === alarm.id)) {
             _alarmList.push(alarm);
        }
      });
   return _alarmList;
 }

  diff(startDate, endDate) {
  let startDateMoment = moment.utc(startDate);
  let endDateMoment = moment.utc(endDate);
  let diffMiliseconds = moment(endDateMoment).diff(startDateMoment);
  let duration = moment.duration(diffMiliseconds);
  let hours = Math.floor(duration.asHours());
  let minutes = moment.utc(diffMiliseconds).format("mm");
  let seconds = moment.utc(diffMiliseconds).format("ss");
  return `${hours}h ${minutes}m ${seconds}s`;
}

  private static readonly MICROSERVICE_GMT3_OFFSET_MS = 3 * 60 * 60 * 1000;

  public undoMicroserviceGmt3(dateString: string): Date {
    if (!dateString) return null;
    try {
      let isoString = dateString.trim();
      if (!isoString.includes('T')) {
        isoString = isoString.replace(' ', 'T');
      }
      if (!isoString.includes('.')) {
        isoString = isoString + '.000';
      }
      if (!isoString.endsWith('Z') && !isoString.match(/[+-]\d{2}:\d{2}$/)) {
        isoString = isoString + 'Z';
      }
      const parsed = new Date(isoString);
      if (isNaN(parsed.getTime())) return null;
      return new Date(parsed.getTime() + DataService.MICROSERVICE_GMT3_OFFSET_MS);
    } catch (error) {
      console.warn('Erro ao desfazer GMT-3 do microserviço:', dateString, error);
      return null;
    }
  }

  /**
   * Converte uma data string para Date considerando o timezone do alarme
   * A Date retornada representa o momento correto, mas quando formatada será exibida no timezone do navegador
   * @param dateString String da data no formato do backend (ex: "2026-01-07 07:20:47.000")
   * @param timezone Timezone do alarme (ex: "-02:00", "-03:00", "UTC", "GMT")
   * @returns Date que representa o momento correto no tempo
   */
  public convertToAlarmTimezone(dateString: string, timezone?: string): Date {
    if (!dateString) return null;
    
    const trimmed = dateString.trim();
    if (/^\d+$/.test(trimmed)) {
      const num = Number(trimmed);
      const ms = num < 1e12 ? num * 1000 : num;
      const parsedDate = new Date(ms);
      return isNaN(parsedDate.getTime()) ? null : parsedDate;
    }
    
    // Normalizar o formato do timezone
    let normalizedTimezone = timezone ? this.normalizeTimezone(timezone) : "-03:00";
    
    // Se não conseguiu normalizar, usar o timezone original ou padrão
    if (!normalizedTimezone || !normalizedTimezone.match(/^[+-]\d{2}:\d{2}$/)) {
      normalizedTimezone = timezone || "-03:00";
    }
    
    try {
      if (trimmed.endsWith('Z') || trimmed.match(/[+-]\d{2}:?\d{2}$/)) {
        const parsedDate = new Date(trimmed);
        return isNaN(parsedDate.getTime()) ? null : parsedDate;
      }
      
      // Converter formato de data do banco para ISO
      let isoString = dateString.trim();
      
      // Se não tem 'T', adicionar
      if (!isoString.includes('T')) {
        isoString = isoString.replace(' ', 'T');
      }
      
      // Garantir que tem milissegundos
      if (!isoString.includes('.')) {
        isoString = isoString + '.000';
      } else {
        // Verificar se tem 3 dígitos de milissegundos
        const millisMatch = isoString.match(/\.(\d+)/);
        if (millisMatch) {
          const millis = millisMatch[1];
          if (millis.length !== 3) {
            // Completar ou truncar para 3 dígitos
            const parts = isoString.split('.');
            isoString = parts[0] + '.' + millis.padEnd(3, '0').substring(0, 3);
          }
        }
      }
      
      // Adicionar o timezone normalizado
      const dateWithTimezone = isoString + normalizedTimezone;
      
      return new Date(dateWithTimezone);
    } catch (error) {
      // Em caso de erro, fallback para comportamento padrão
      console.warn('Erro ao converter timezone:', timezone, 'String:', dateString, error);
      const fallbackDate = dateString.includes('.') ? dateString : dateString + '.000';
      return new Date(fallbackDate.replace(' ', 'T') + "-03:00");
    }
  }

  /**
   * Converte uma Date do timezone do alarme para o timezone do navegador
   * @param date Date que representa um momento no timezone do alarme
   * @param alarmTimezone Timezone do alarme (ex: "-02:00", "-03:00")
   * @returns Date ajustada para quando for formatada, mostrar a hora correta no timezone do navegador
   */
  public convertFromAlarmTimezoneToBrowser(date: Date, alarmTimezone?: string): Date {
    if (!date) return null;
    
    // Se não há timezone do alarme ou é o mesmo do navegador, retornar sem alteração
    if (!alarmTimezone || !this.isTimezoneDifferent(alarmTimezone)) {
      return date;
    }
    
    // Obter offsets em minutos
    const browserOffset = this.getBrowserTimezoneOffset();
    const alarmOffset = this.normalizeTimezone(alarmTimezone);
    
    const browserMinutes = this.timezoneToMinutes(browserOffset);
    const alarmMinutes = this.timezoneToMinutes(alarmOffset);
    
    // Calcular diferença: se o alarme está em -02:00 e o navegador em -03:00
    const diffMinutes = browserMinutes - alarmMinutes;
    
    // Ajustar a Date: se a hora do alarme é 07:20 em -02:00, queremos mostrar 06:20 em -03:00
    const adjustedDate = new Date(date.getTime() - (diffMinutes * 60 * 1000));
    
    return adjustedDate;
  }

  /**
   * Obtém o offset do timezone do navegador em formato ±HH:MM
   * @returns String no formato "-03:00" ou "+05:30"
   */
  public getBrowserTimezoneOffset(): string {
    const offset = new Date().getTimezoneOffset();
    // getTimezoneOffset retorna o offset em minutos, mas com sinal invertido
    // Se retorna -180 (Brasil), significa UTC-3, então precisamos inverter
    const offsetHours = Math.floor(Math.abs(offset) / 60);
    const offsetMinutes = Math.abs(offset) % 60;
    const sign = offset <= 0 ? '+' : '-'; // Invertido porque getTimezoneOffset é invertido
    
    return `${sign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`;
  }

  /**
   * Compara o timezone do alarme com o timezone do navegador
   * @param alarmTimezone Timezone do alarme (ex: "-01:00", "UTC")
   * @returns true se os timezones forem diferentes
   */
  public hasExplicitTimezone(timezone?: string): boolean {
    if (timezone == null) {
      return false;
    }

    const trimmedTimezone = String(timezone).trim();
    if (trimmedTimezone === '') {
      return false;
    }

    const normalizedLiteral = trimmedTimezone.toLowerCase();
    if (normalizedLiteral === 'null' || normalizedLiteral === 'undefined') {
      return false;
    }

    return true;
  }

  public shouldShowAlarmDatetimeTooltip(alarmTimezone?: string): boolean {
    return this.isTimezoneDifferent(alarmTimezone);
  }

  public shouldShowAvailableMediaAtTooltip(alarmTimezone?: string): boolean {
    if (!this.hasExplicitTimezone(alarmTimezone)) {
      return false;
    }
    return this.getBrowserTimezoneOffset() !== '-03:00';
  }

  public isTimezoneDifferent(alarmTimezone?: string): boolean {
    const browserOffset = this.getBrowserTimezoneOffset();
    const normalizedAlarm = this.normalizeTimezone(alarmTimezone || "-03:00");
    const normalizedBrowser = this.normalizeTimezone(browserOffset);

    return normalizedAlarm !== normalizedBrowser;
  }

  /**
   * Normaliza um timezone para formato ±HH:MM para comparação
   * @param timezone Timezone em qualquer formato
   * @returns Timezone normalizado no formato ±HH:MM
   */
  public normalizeTimezone(timezone: string): string {
    if (!timezone) return null;

    const trimmedTimezone = String(timezone).trim();
    if (trimmedTimezone === '') return null;

    const offsetMatch = trimmedTimezone.match(/^([+-])(\d{1,2}):(\d{2})$/);
    if (offsetMatch) {
      const sign = offsetMatch[1];
      const hours = parseInt(offsetMatch[2], 10);
      const minutes = offsetMatch[3];
      return `${sign}${String(hours).padStart(2, '0')}:${minutes}`;
    }
    
    // Para UTC/GMT
    if (trimmedTimezone === "UTC" || trimmedTimezone === "GMT" || trimmedTimezone === "0" || trimmedTimezone === "UTC+0" || trimmedTimezone === "GMT+0") {
      return "+00:00";
    }
    
    // Tentar parsear formatos como UTC+3, GMT-5
    const utcMatch = trimmedTimezone.match(/(UTC|GMT)([+-])(\d+)/);
    if (utcMatch) {
      const sign = utcMatch[2];
      const hours = parseInt(utcMatch[3], 10);
      return `${sign}${String(hours).padStart(2, '0')}:00`;
    }
    
    // Se não conseguir normalizar, retornar original
    return trimmedTimezone;
  }

  /**
   * Converte uma data para o timezone do navegador e retorna formatada
   * @param date Data a ser convertida
   * @param alarmTimezone Timezone do alarme
   * @returns String formatada no horário local do navegador
   */
  public formatDateInBrowserTimezone(date: Date, alarmTimezone?: string): string {
    if (!date) return null;
    
    // Se o timezone do alarme é o mesmo do navegador, retornar formatado normalmente
    if (!this.isTimezoneDifferent(alarmTimezone)) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    }
    
    // Converter para o timezone do navegador
    // A data já está no timezone do alarme, então precisamos ajustar
    const browserOffset = this.getBrowserTimezoneOffset();
    const alarmOffset = this.normalizeTimezone(alarmTimezone);
    
    // Calcular diferença em minutos
    const browserMinutes = this.timezoneToMinutes(browserOffset);
    const alarmMinutes = this.timezoneToMinutes(alarmOffset);
    const diffMinutes = browserMinutes - alarmMinutes;
    
    const adjustedDate = new Date(date.getTime() + (diffMinutes * 60 * 1000));
    
    return moment(adjustedDate).format('DD/MM/YYYY HH:mm:ss');
  }

  public formatBackendFormattedDate(formattedStr: string, useComma?: boolean): string {
    if (!formattedStr || typeof formattedStr !== 'string') return null;
    const trimmed = formattedStr.trim();
    const parts = trimmed.split(/\s+/);
    if (parts.length < 2) return trimmed;
    const sep = useComma ? ', ' : ' ';

    if (parts.length >= 3) {
      const offsetPart = parts[2];
      const offsetNormalized = (offsetPart === '+0' || offsetPart === '-0') ? (offsetPart + '0:00') : offsetPart;
      const isoStr = parts[0] + 'T' + parts[1] + (offsetNormalized.startsWith('+') || offsetNormalized.startsWith('-') ? offsetNormalized : '');
      const date = new Date(isoStr);
      if (!isNaN(date.getTime())) return moment(date).format(useComma ? 'DD/MM/YYYY, HH:mm:ss' : 'DD/MM/YYYY HH:mm:ss');
    }

    const [year, month, day] = parts[0].split('-');
    const timePart = parts[1];
    const [hour, minute, secondsWithMs] = timePart.split(':');
    const seconds = secondsWithMs ? secondsWithMs.split('.')[0] : '00';
    if (!day || !month || !year) return trimmed;
    return `${day}/${month}/${year}${sep}${hour}:${minute}:${seconds}`;
  }

  public getAlarmDatetimeDisplayValue(alarm: any): string | Date | null {
    if (!alarm) return null;
    const datetimestamp = this.getAlarmDatetimestampRaw(alarm);
    if (datetimestamp != null) return datetimestamp;
    const formatted = alarm.datetimestampFormatted != null ? alarm.datetimestampFormatted : alarm['datetimestamp_formatted'];
    if (formatted) return formatted;

    const normalizedTimezone = this.normalizeTimezone(alarm.timeZone || '-03:00');
    if (normalizedTimezone !== '-03:00' && alarm.datetime != null) {
      const derived = this.deriveAlarmDatetimeFromMicroserviceDatetime(alarm.datetime, alarm.timeZone);
      if (derived) return derived;
    }

    return alarm.datetime != null ? alarm.datetime : null;
  }

  public getAlarmAvailableMediaAtDisplayValue(alarm: any): string | Date | null {
    if (!alarm) return null;
    const availableMediaAtTimestamp = alarm.availableMediaAtTimestamp != null
      ? alarm.availableMediaAtTimestamp
      : (alarm['available_media_at_timestamp'] != null ? alarm['available_media_at_timestamp'] : null);
    if (availableMediaAtTimestamp != null) return availableMediaAtTimestamp;
    const formatted = alarm.availableMediaAtTimestampFormatted != null
      ? alarm.availableMediaAtTimestampFormatted
      : alarm['available_media_at_timestamp_formatted'];
    if (formatted) return formatted;

    const rawAvailableMediaAt = typeof alarm.availableMediaAt === 'string'
      ? alarm.availableMediaAt
      : (alarm['available_media_at'] != null ? alarm['available_media_at'] : null);
    if (rawAvailableMediaAt) return rawAvailableMediaAt;

    return alarm.availableMediaAt != null ? alarm.availableMediaAt : null;
  }

  private getAlarmDatetimestampRaw(alarm: any): string | Date | null {
    if (!alarm) return null;
    const datetimestamp = alarm.datetimestamp != null
      ? alarm.datetimestamp
      : (alarm['datetimestamp'] != null ? alarm['datetimestamp'] : alarm['date_timestamp']);
    if (datetimestamp == null) return null;
    if (datetimestamp instanceof Date) {
      return isNaN(datetimestamp.getTime()) ? null : moment(datetimestamp).format('YYYY-MM-DDTHH:mm:ss');
    }
    return datetimestamp;
  }

  public deriveAlarmDatetimeFromMicroserviceDatetime(datetime: string | Date, timeZone?: string): string | null {
    const normalizedTimezone = this.normalizeTimezone(timeZone || '-03:00');
    if (normalizedTimezone === '-03:00' || datetime == null) return null;

    const clientOffsetMin = this.timezoneToMinutes(normalizedTimezone);
    const microserviceOffsetMin = this.timezoneToMinutes('-03:00');
    const diffMs = (clientOffsetMin - microserviceOffsetMin) * 60 * 1000;

    let baseDate: Date;
    if (datetime instanceof Date) {
      baseDate = new Date(datetime.getTime());
    } else {
      baseDate = this.parseAlarmTimestampToDate(String(datetime), timeZone)
        || new Date(String(datetime).trim().replace(' ', 'T'));
    }

    if (!baseDate || isNaN(baseDate.getTime())) return null;

    return moment(new Date(baseDate.getTime() - diffMs)).format('YYYY-MM-DDTHH:mm:ss');
  }

  public getAlarmDatetimeAsDate(alarm: any): Date | null {
    if (!alarm) return null;
    const alarmDatetimeDisplayValue = this.getAlarmDatetimeDisplayValue(alarm);
    if (alarmDatetimeDisplayValue == null) return null;
    if (alarmDatetimeDisplayValue instanceof Date) {
      return isNaN(alarmDatetimeDisplayValue.getTime()) ? null : alarmDatetimeDisplayValue;
    }
    return this.parseAlarmTimestampToDate(String(alarmDatetimeDisplayValue), alarm.timeZone);
  }

  public getAlarmAvailableMediaAtAsDate(alarm: any): Date | null {
    if (!alarm) return null;
    const alarmAvailableMediaAtDisplayValue = this.getAlarmAvailableMediaAtDisplayValue(alarm);
    if (alarmAvailableMediaAtDisplayValue == null) return null;
    if (alarmAvailableMediaAtDisplayValue instanceof Date) {
      return isNaN(alarmAvailableMediaAtDisplayValue.getTime()) ? null : alarmAvailableMediaAtDisplayValue;
    }
    return this.parseAlarmTimestampToDate(String(alarmAvailableMediaAtDisplayValue), alarm.timeZone);
  }

  public getAlarmDisplayDatetime(alarm: any, useComma?: boolean): string {
    if (!alarm) return null;
    const formatted = alarm.datetimestampFormatted != null ? alarm.datetimestampFormatted : alarm['datetimestamp_formatted'];
    if (formatted) return this.formatBackendFormattedDate(formatted, useComma);
    const displayValue = this.getAlarmDatetimeDisplayValue(alarm);
    if (displayValue == null) return null;
    if (typeof displayValue === 'string') {
      const parsed = this.parseAlarmTimestampToDate(displayValue, alarm.timeZone);
      if (parsed) return moment(parsed).format(useComma ? 'DD/MM/YYYY, HH:mm:ss' : 'DD/MM/YYYY HH:mm:ss');
    }
    const datetimeToFormat = displayValue instanceof Date ? displayValue : alarm.datetime;
    if (!datetimeToFormat) return null;
    return moment(datetimeToFormat).format(useComma ? 'DD/MM/YYYY, HH:mm:ss' : 'DD/MM/YYYY HH:mm:ss');
  }

  public formatRawDateTimeForTooltip(rawValue: string | Date): string {
    if (rawValue == null) return null;
    let str: string = typeof rawValue === 'string' ? rawValue.trim() : (rawValue instanceof Date ? rawValue.toISOString() : String(rawValue));
    str = str.replace('T', ' ').replace(/Z$/i, '').replace(/\s+[+-]\d{2}:?\d{2}$/, '').trim();
    const dateTimeMatch = str.match(/^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?/);
    if (dateTimeMatch) {
      const [, year, month, day, hour, minute, seconds, milliseconds] = dateTimeMatch;
      return milliseconds != null
        ? `${day}/${month}/${year} ${hour}:${minute}:${seconds}.${milliseconds.padStart(3, '0').slice(0, 3)}`
        : `${day}/${month}/${year} ${hour}:${minute}:${seconds}`;
    }
    return null;
  }

  public getDateTimezoneTooltip(rawValue: string | Date, timeZone?: string): string {
    if (!rawValue || !this.isTimezoneDifferent(timeZone)) return null;
    const tooltipStr = this.formatRawDateTimeForTooltip(rawValue);
    return tooltipStr ? `${tooltipStr} (${this.normalizeTimezone(timeZone)})` : null;
  }
  
  public getAlarmTooltip(alarm: any): string {
    if (!alarm) return null;
    if (alarm._timezoneDifferent === true && alarm._tooltipDatetime) return alarm._tooltipDatetime;
    if (alarm._timezoneDifferent === false) return null;
    const raw = typeof alarm.datetimestamp === 'string' ? alarm.datetimestamp : alarm.datetime;
    return this.getDateTimezoneTooltip(raw, alarm.timeZone);
  }

  /**
   * Formata uma data no timezone do alarme (hora original do banco)
   * @param date Data que representa o momento correto
   * @param alarmTimezone Timezone do alarme
   * @returns String formatada no timezone do alarme
   */
  public formatDateInAlarmTimezone(date: Date, alarmTimezone?: string): string {
    if (!date) return null;
    
    if (!alarmTimezone) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    }
    
    // Converter o timezone para minutos de offset
    const offsetMinutes = this.timezoneToMinutes(this.normalizeTimezone(alarmTimezone));
    
    // Usar utcOffset do moment para formatar no timezone do alarme
    return moment(date).utcOffset(offsetMinutes).format('DD/MM/YYYY HH:mm:ss');
  }

  /**
   * Converte um timezone no formato ±HH:MM para minutos de offset
   * @param timezone Timezone no formato ±HH:MM
   * @returns Offset em minutos
   */
  private timezoneToMinutes(timezone: string): number {
    if (!timezone) return 0;
    
    const match = timezone.match(/^([+-])(\d{2}):(\d{2})$/);
    if (match) {
      const sign = match[1];
      const hours = parseInt(match[2], 10);
      const minutes = parseInt(match[3], 10);
      const totalMinutes = (hours * 60) + minutes;
      return sign === '+' ? totalMinutes : -totalMinutes;
    }
    
    return 0;
  }

  public parseAlarmTimestampToDate(value: string | Date, timeZone?: string): Date | null {
    if (value == null) return null;
    if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
    if (typeof value !== 'string') return null;

    const trimmed = value.trim();
    let parsedDate: Date = null;

    if (trimmed.indexOf('T') >= 0 || trimmed.indexOf('Z') >= 0) {
      parsedDate = new Date(trimmed);
    } else {
      const withSpace = trimmed.match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}:\d{2}(?:\.\d+)?)\s+([+-])(\d{2})(\d{2})$/);
      const noSpace = trimmed.match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}:\d{2}(?:\.\d+)?)([+-])(\d{2})(\d{2})$/);
      const match = withSpace || noSpace;
      if (match) {
        const [, datePart, timePart, sign, offsetHours, offsetMinutes] = match;
        parsedDate = new Date(`${datePart}T${timePart}${sign}${offsetHours}:${offsetMinutes}`);
      } else {
        const noOffset = trimmed.match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}:\d{2}(?:\.\d+)?)$/);
        if (noOffset && timeZone) {
          const [, datePart, timePart] = noOffset;
          const normalized = this.normalizeTimezone(timeZone);
          if (normalized && normalized.match(/^[+-]\d{2}:\d{2}$/)) {
            parsedDate = new Date(`${datePart}T${timePart}${normalized}`);
          }
        }
        if (parsedDate == null || isNaN(parsedDate.getTime())) {
          parsedDate = new Date(trimmed);
        }
      }
    }

    return parsedDate != null && !isNaN(parsedDate.getTime()) ? parsedDate : null;
  }

  public applyPortalAlarmDatetimeTimezone(alarm: any): any {
    if (!alarm) return alarm;

    if (alarm.timeZone === '0') {
      alarm.timeZone = '+00:00';
    }

    const normalizedTimezone = this.normalizeTimezone(alarm.timeZone || '-03:00');
    const isDifferentFromMicroserviceOffset = normalizedTimezone !== '-03:00';
    const showAvailableMediaAtTooltip = this.shouldShowAvailableMediaAtTooltip(alarm.timeZone);

    const datetimestamp = this.getAlarmDatetimestampRaw(alarm);
    const availableMediaAtTimestamp = alarm.availableMediaAtTimestamp != null
      ? alarm.availableMediaAtTimestamp
      : (alarm['available_media_at_timestamp'] != null ? alarm['available_media_at_timestamp'] : null);

    alarm['_showAvailableMediaAtTooltip'] = showAvailableMediaAtTooltip;

    if (datetimestamp) {
      const parsedAlarmDatetimeFromDatetimestamp = this.parseAlarmTimestampToDate(
        typeof datetimestamp === 'string' ? datetimestamp : String(datetimestamp),
        alarm.timeZone
      );
      if (parsedAlarmDatetimeFromDatetimestamp) alarm.datetime = parsedAlarmDatetimeFromDatetimestamp;
      if (typeof datetimestamp === 'string') {
        alarm.datetimestamp = datetimestamp;
      }
    } else if (isDifferentFromMicroserviceOffset) {
      if (alarm.datetime) {
        const derivedAlarmDatetimestamp = this.deriveAlarmDatetimeFromMicroserviceDatetime(alarm.datetime, alarm.timeZone);
        if (derivedAlarmDatetimestamp) {
          alarm.datetimestamp = derivedAlarmDatetimestamp;
          const parsedAlarmDatetimeFromDerived = this.parseAlarmTimestampToDate(derivedAlarmDatetimestamp, alarm.timeZone);
          if (parsedAlarmDatetimeFromDerived) alarm.datetime = parsedAlarmDatetimeFromDerived;
        } else {
          alarm.datetime = this.undoMicroserviceGmt3(alarm.datetime.toString());
        }
      }
    } else if (alarm.datetime && alarm.timeZone) {
      alarm.datetime = this.convertToAlarmTimezone(alarm.datetime.toString(), alarm.timeZone);
    }

    if (availableMediaAtTimestamp) {
      const parsedAvailableMediaAtFromTimestamp = this.parseAlarmTimestampToDate(
        typeof availableMediaAtTimestamp === 'string' ? availableMediaAtTimestamp : String(availableMediaAtTimestamp),
        alarm.timeZone
      );
      if (parsedAvailableMediaAtFromTimestamp) alarm.availableMediaAt = parsedAvailableMediaAtFromTimestamp;
      if (typeof availableMediaAtTimestamp === 'string') {
        alarm.availableMediaAtTimestamp = availableMediaAtTimestamp;
      }
    } else if (alarm.availableMediaAt && alarm.timeZone) {
      alarm.availableMediaAt = this.convertToAlarmTimezone(alarm.availableMediaAt.toString(), alarm.timeZone);
    }

    const portalProcessingNow = new Date();
    const alarmDatetimeForDelay = alarm.datetime ? new Date(alarm.datetime) : new Date();
    const availableMediaAtForDelay = new Date(alarm.availableMediaAt ? alarm.availableMediaAt : alarm.insertDate);
    const auditCreateDatetime = alarm.auditCreate_date ? new Date(alarm.auditCreate_date) : null;
    const availableMediaAtElapsedSinceNow = this.diff(availableMediaAtForDelay, portalProcessingNow);
    const alarmToAvailableMediaDelay = (this.diff(alarmDatetimeForDelay, availableMediaAtForDelay)).includes('-')
      ? '0h 00m 00s'
      : this.diff(alarmDatetimeForDelay, availableMediaAtForDelay);
    const availableMediaAtToTreatmentDelay = auditCreateDatetime
      ? this.diff(availableMediaAtForDelay, auditCreateDatetime)
      : null;

    alarm.delayDate = alarmToAvailableMediaDelay;
    alarm.timeRead = availableMediaAtElapsedSinceNow;
    alarm.timeToTreat = auditCreateDatetime ? availableMediaAtToTreatmentDelay : null;

    alarm['_timezoneDifferent'] = this.shouldShowAlarmDatetimeTooltip(alarm.timeZone);
    alarm['_tooltipDatetime'] = this.buildAlarmDatetimeTooltip(alarm, normalizedTimezone);
    alarm['_tooltipAvailableMediaAt'] = showAvailableMediaAtTooltip
      ? this.buildAlarmAvailableMediaAtTooltip(alarm)
      : null;

    return alarm;
  }

  private buildAlarmDatetimeTooltip(alarm: any, normalizedTimezone: string): string | null {
    if (!alarm || !this.shouldShowAlarmDatetimeTooltip(alarm.timeZone)) {
      return null;
    }

    const alarmDate = this.getAlarmDatetimeAsDate(alarm);
    if (!alarmDate) {
      return null;
    }

    const tooltipDatetimeStr = this.formatDateInAlarmTimezone(alarmDate, alarm.timeZone);
    return tooltipDatetimeStr ? `${tooltipDatetimeStr} (${normalizedTimezone})` : null;
  }

  private buildAlarmAvailableMediaAtTooltip(alarm: any): string | null {
    if (!alarm) {
      return null;
    }

    const availableMediaAtDate = this.getAlarmAvailableMediaAtAsDate(alarm);
    if (!availableMediaAtDate) {
      return null;
    }

    const tooltipAvailableMediaAtStr = this.formatDateInAlarmTimezone(availableMediaAtDate, '-03:00');
    return tooltipAvailableMediaAtStr ? `${tooltipAvailableMediaAtStr} (-03:00)` : null;
  }

  public applyPortalAlarmDatetimeTimezoneList(alarms: any[]): any[] {
    if (!alarms) return alarms;
    return alarms.map(alarm => this.applyPortalAlarmDatetimeTimezone(alarm));
  }

  public registerAlarms(_alarmsAndInfractions: any) {
    if (_alarmsAndInfractions.alarmList) {
      _alarmsAndInfractions.alarmList.forEach((alarm) => {
        this.applyPortalAlarmDatetimeTimezone(alarm);

          if (!this.roadDefendData.alarmList.find(_alarm_ => _alarm_ && _alarm_.id === alarm.id)) {
            this.roadDefendData.alarmList.push(alarm);
          }
      });
      
      _alarmsAndInfractions.alarmList.sort((firstAlarm, secondAlarm) => {
        const firstAlarmDatetimeWithTimezone = this.getAlarmDatetimeAsDate(firstAlarm);
        const secondAlarmDatetimeWithTimezone = this.getAlarmDatetimeAsDate(secondAlarm);
        const firstAlarmSortEpochMs = firstAlarmDatetimeWithTimezone ? firstAlarmDatetimeWithTimezone.getTime() : 0;
        const secondAlarmSortEpochMs = secondAlarmDatetimeWithTimezone ? secondAlarmDatetimeWithTimezone.getTime() : 0;
        return secondAlarmSortEpochMs - firstAlarmSortEpochMs;
      });
  
      this.roadDefendData.filteredAlarmList = _alarmsAndInfractions.alarmList;
    } 

    if (_alarmsAndInfractions.infractionInformationList) {

      this.roadDefendData.infractionList = _alarmsAndInfractions.infractionInformationList;
      this.roadDefendData.filteredInfractionList = _alarmsAndInfractions.infractionInformationList;
    }

    return this.roadDefendData.alarmList;
  }

  public setReadFilteredAlarmList(alarmId: number) {
    this.roadDefendData.filteredAlarmList.map((alarm: Alarm)=>{
      if (alarm.id === alarmId) {
        alarm.alarmRead = true;
      }
    });
  }

  public setFilteredAlarmList(filteredAlarmList: Alarm[]) {
    return this.roadDefendData.filteredAlarmList = filteredAlarmList ;
  }

  public getFilteredAlarmList(): Alarm[] {
    return this.roadDefendData.filteredAlarmList;
  }

  public getFilteredAlarmDtoList(): AlarmDto[] {

    return this.roadDefendData.filteredAlarmList.map(
      (alarm: Alarm) => <AlarmDto>this.convertAlarmToAlarmDto(alarm)
    );
  }

  public getFilteredInfractionsDtoList():InfractionDto[] {
    return this.roadDefendData.filteredInfractionList.map(
      (infraction: Infraction) => <InfractionDto>this.convertInfractionDto(infraction)
    )
  }

  public getFilteredAlarmDtoListByDriverAndType(driverId: number, typeAlarm: number): AlarmDto[] {
    let _listFiltered: AlarmDto[] = this.getFilteredAlarmDtoList();
    return _listFiltered.filter((alarm: AlarmDto)=>{
        return alarm.driverId == driverId && alarm.typeAlarm == typeAlarm;
    });
  }

  public getFilteredAlarmDtoListByDriver(driverId: number): AlarmDto[] {
    let _listFiltered: AlarmDto[] = this.getFilteredAlarmDtoList();
    return _listFiltered.filter((alarm: AlarmDto)=>{
      return alarm.driverId == driverId;
  });
  }

  public getFilteredAlarmDtoListByType(type:number): AlarmDto[] {
    let _listFiltered: AlarmDto[] = this.getFilteredAlarmDtoList();
    return _listFiltered.filter((alarm: AlarmDto)=>{
        return alarm.typeAlarm == type;
    });
  }

  public getFilteredAlarmDtoCategoryByDriverType(type:number): AlarmDto[] {
      let _result : AlarmDto[] = new Array<AlarmDto>()
      ,  _alarms : AlarmDto[] = this.getFilteredAlarmDtoListByType(type);

      _alarms.forEach((_alarm: AlarmDto)=>{
        let _alarmByType: AlarmDto = _result.find((alarm: AlarmDto)=> {return _alarm.driverId === alarm.driverId && _alarm.typeAlarm === alarm.typeAlarm});

        if (_alarmByType) {
          // sum quantity
          _alarmByType.totalCategory = _alarmByType.totalCategory + 1;

        } else {
          // push array, count by row
          _alarmByType = Object.assign(<AlarmDto>{}, _alarm);
          _alarmByType.totalCategory = 1;
          _alarmByType.totalCount = _alarms.length;
          _alarmByType.assetIdentification = _alarm.vehicle_plates;
          _alarmByType.driverName = (_alarmByType.driver_firstname)?_alarmByType.driver_firstname:''
          + ' ' + (_alarmByType.driver_lastname)?_alarmByType.driver_lastname:'';
          _result.push(_alarmByType);
        }

      });

       return _result;
  }


  public getFilteredAlarmDtoCategoryByDriverAndType(): AlarmDto[] {
    let _category : AlarmDto[] = new Array<AlarmDto>();

    this.roadDefendData.filteredAlarmList.forEach((_alarm: AlarmDto)=>{
        let _alarmCategory: AlarmDto = _category.find((alarm: AlarmDto)=> {
          return _alarm.driverId === alarm.driverId && _alarm.typeAlarm === alarm.typeAlarm});

        if (_alarmCategory) {
          // sum quantity
          _alarmCategory.totalCount = _alarmCategory.totalCount + 1;
        } else {
          // push array, count by row
          _alarmCategory = Object.assign(_alarm);
          _alarmCategory.totalCount = 1;
          _alarmCategory.assetIdentification = _alarm.vehicle_plates;
          _alarmCategory.driverName = (_alarmCategory.driver_firstname)?_alarmCategory.driver_firstname:''
          + ' ' + (_alarmCategory.driver_lastname)?_alarmCategory.driver_lastname:'';
          _category.push(_alarmCategory);
        }

    });

    return _category;
  }


public getAlarmList(): Alarm[] {
    return this.roadDefendData.alarmList;
  }

  public clearAlarms() {
    this.roadDefendData.alarmList = [];
  }

  public registerAlarmTypes(alarmTypes: AlarmType[]): AlarmType[] {
    this.roadDefendData.alarmTypeList = alarmTypes;
    return this.roadDefendData.alarmTypeList;
  }
  // *****************************************************************
  // repository
  // register all relational alarm data
  private repoDriverById = true;
 public registerAllAlarmsData(_alarms: Alarm[]) {
    let alarmList: Alarm[] = [];
    let _drivers: number[] = [];
    let _assets: number[] = [];
   _alarms.forEach((alarm) => {
        // check alarm
        if (!this.roadDefendData.alarmList.find(_alarm_ => _alarm_ && _alarm_.id === alarm.id)) {
           // request async alarm data in repository
            this.loadRepositoryAlarmDataByAlarmId(alarm.id);
        }

        // check driver
        if (alarm.driverId && !this.roadDefendData.driverList.find(_driver_ => _driver_ && _driver_.id === alarm.driverId)) {
            // request async driver data in repository
            if (!_drivers.find(_driverId => _driverId && _driverId === alarm.driverId)) {
               _drivers.push(alarm.driverId);
               this.loadRepositoryDriverDataByDriverId(alarm.driverId);
            }
        }

        // check asset
        if (alarm.assetId && !this.roadDefendData.assetList.find(_asset_ => _asset_ && _asset_.id === alarm.assetId)) {
            // request async asset data in repository
            if (!_assets.find(_assetId => _assetId && _assetId === alarm.assetId)) {
               _assets.push(alarm.assetId);
               this.loadRepositoryAssetDataByAssetId(alarm.assetId);
            }
        }


      });
 }

 public loadRepositoryDriverDataByDriverId(_driverId: number): Observable<RoadDefendData> {

    let _ws = this.configService.webServices;


    if (_ws['repositoryDriverDataByDriverId'].mock) {
       let _driver: Driver = this.mockService.getDriverByDriverId(_driverId);
      if (_driver) {
          this.roadDefendData.driverList.push(_driver);
      }
      return observableOf(this.roadDefendData);
    } else{

      this.driverService.selectDriverById(_driverId).subscribe(
        (_driver) => {
           //let  _driver: Driver = <Driver>(this.itemsService.getSerialized<Driver>(data[0]));
           if (_driver && !this.roadDefendData.driverList.find(driver => driver && driver.id === _driver.id)) {
              this.roadDefendData.driverList.push(_driver);
              console.info('this.roadDefendData.driverList', this.roadDefendData.driverList);
           }
        });
    }

  }

public loadRepositoryAssetDataByAssetId(_assetId: number): Observable<RoadDefendData> {

    let _ws = this.configService.webServices;

    if (_ws['repositoryAssetDataByAssetId'].mock) {
       let _asset: Asset = this.mockService.getAssetByAssetId(_assetId);
      if (_asset) {
          this.roadDefendData.assetList.push(_asset);
      }
      return observableOf(this.roadDefendData);
    } else{

      /* this.assetService.getAssetById(_assetId).subscribe(
        (_asset) => {
           if (_asset && !this.roadDefendData.assetList.find(asset => asset && asset.id === _asset.id)) {
              this.roadDefendData.assetList.push(_asset);
           }
        }); */
    }

  }

  public loadRepositoryAlarmDataByAlarmId(_alarmId: number): Observable<RoadDefendData> {
    let _ws = this.configService.webServices;
    if (_ws['repositoryAlarmDataByAlarmId'].mock) {
       let _alarm: Alarm = this.mockService.getAlarmByAlarmId(_alarmId);
      if (_alarm) {
          this.roadDefendData.alarmList.push(_alarm);
      }
      return observableOf(this.roadDefendData);
    } else
    return observableForkJoin([
      this.http.get(_ws['alarmById'].url(this._baseUrl, _alarmId)).pipe(map(res => res.json()))
    ]).pipe(
    map((data: any[]) => {
       let  _alarm: Alarm = <Alarm>(this.itemsService.getSerialized<Alarm>(data[0]));
       if (_alarm) this.roadDefendData.alarmList.push(_alarm);
      return this.roadDefendData;
    }),
    catchError(this.handleError),);
  }


  public loadRepositoryDataByFilter(_filter: FilterAlarms): Observable<RoadDefendData> {

    let _ws = this.configService.webServices;
    if (_ws['repositoryDataByFilter'].mock) {
        let _alarms: Alarm[] = this.mockService.getAlarmsByFilter(_filter);
        let  _customers: Customer[] = this.mockService.getCustomersByCustIds(_filter.selectedCustomers);
        let  _drivers: Driver[] = this.mockService.getDriversByCustIds(_filter.selectedCustomers);
        let  _assets: Asset[] = this.mockService.getAssetsByCustIds(_filter.selectedCustomers);
        this.roadDefendData.alarmList = _alarms;
        this.roadDefendData.customerList = _customers;
        this.roadDefendData.driverList = _drivers;
        this.roadDefendData.assetList = _assets;

        return observableOf(this.roadDefendData);
    } else
    return observableForkJoin([
      this.http.get(_ws['alarmsByFilter'].url(this._baseUrl, _filter)).pipe(map(res => res.json())),
      this.http.get(_ws['customersByCustomerIds'].url(this._baseUrl, _filter.selectedCustomers)).pipe(map(res => res.json())),
      this.http.get(_ws['driversByCustomerIds'].url(this._baseUrl, _filter.selectedCustomers)).pipe(map(res => res.json())),
      this.http.get(_ws['assetsByCustomerIds'].url(this._baseUrl, _filter.selectedCustomers)).pipe(map(res => res.json())),
    ]).pipe(
    map((data: any[]) => {
      this.roadDefendData.alarmList = <Alarm[]>(this.itemsService.getSerialized<Alarm[]>(data[0]));
      this.roadDefendData.customerList = <Customer[]>(this.itemsService.getSerialized<Customer[]>(data[1]));
      this.roadDefendData.driverList = <Driver[]>(this.itemsService.getSerialized<Driver[]>(data[2]));
      this.roadDefendData.assetList = <Asset[]>(this.itemsService.getSerialized<Asset[]>(data[3]));

      return this.roadDefendData;
    }),
    catchError(this.handleError),);
  }

  private handleError(error: any) {
    let errMsg = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    return observableThrowError(errMsg);
  }


  // *****************************************************************
  // Workspace

  public registerWorkspace(_workspace: Workspace): Workspace {
    _workspace.currentUser = this.currentUser();

    if(_workspace.isDealer) {
      const DEALER_OBJ = { id: 0, permissions: 4, permissionDesc: 'ROLE_DEALER_TOTAL' };

      if(_workspace.accessControlDesc) {
        _workspace.accessControlDesc.push(DEALER_OBJ);
      }else{
        _workspace.accessControlDesc = [DEALER_OBJ];
      }
    }

    window.localStorage.setItem('userWorkspace', JSON.stringify(_workspace));
    this.roadDefendData.workspace = _workspace;

    return this.roadDefendData.workspace;
  }

  public getWorkspace(): Workspace {
     let wk: Workspace = this.roadDefendData.workspace,
     user: User = this.currentUser();

     if (
      !user ||
      (user && wk && user.id !== wk.currentUserId) ||
      (wk && wk.userCustomerChildIds && wk.userCustomerChildIds.length < 1)
    ) {
      return null;
    } else {

      return wk;
    }
  }

  havePermission(fragment: string, rootFragment?: string){
    let wk: Workspace = this.getWorkspace();
    let findedRootPermission = wk.accessControlDesc.find((ac : AccessControlDesc) => this.getPermissionRole(ac.permissionDesc) == rootFragment);        
    let findedPermission = wk.accessControlDesc.find((ac : AccessControlDesc) => this.getPermissionRole(ac.permissionDesc) == fragment);

    if((rootFragment && !findedRootPermission) || !findedPermission) this.router.navigate(['f/fatigue']);
}

  hasPermission(fragment: string){
    let wk: Workspace = this.getWorkspace();
    let permissionFound = wk.accessControlDesc.find((ac : AccessControlDesc) => this.getPermissionRole(ac.permissionDesc) == fragment);
    
    return permissionFound != null
  }

public currentUser(): User {
    let user: User = JSON.parse(window.localStorage.getItem('currentUser'));
    return user;
  }


  // *****************************************************************
  // AlarmType
  public getAlarmTypeById(alarmTypeId: number) {
    return this.roadDefendData.alarmTypeList.find(alamType => alamType && alamType.id === alarmTypeId);
  }

  public getAlarmTypeByType(alarmType: string) {
    return this.roadDefendData.alarmTypeList.find(alamType => alamType && alamType.identification === alarmType);
  }

  // *****************************************************************
  // customers
  public registerCustomers(customers: Customer[]): Customer[] {
    let result: Customer[] = [];
    try{
          if (customers)
              customers.forEach((customer) => {
                let _customer:Customer;
                  if (!this.roadDefendData.customerList) this.roadDefendData.customerList = [];
                  _customer = this.roadDefendData.customerList.find(mcustomer => mcustomer && mcustomer.id === customer.id);
                  if (!_customer) {
                    this.roadDefendData.customerList.push(customer);
                  }

              });
        result = this.roadDefendData.customerList;
    }catch(e) {
        console.log('registerCustomers Error:' + e);
    }

    return result;
  }

  public getCustomerById(customerId: number): Customer {
    let result : Customer;
    try{
      if (this.roadDefendData.customerList && this.roadDefendData.customerList.length > 0) {
        result = this.roadDefendData.customerList.find(customer => customer && customer.id === customerId)
      }
    } catch(e) {console.error('Error (getCustomerById):', e)}

    return result;
  }

  public getAllCustomers(): Customer[] {
    return this.roadDefendData.customerList;
  }

  public getCustomerByDriverId(driverId: number): Customer {
    let driver: Driver = this.getDriverById(driverId)
    , result: Customer;

    if (driver && this.roadDefendData.customerList.length > 0) {
      result = this.roadDefendData.customerList.find((customer : Customer) => customer.customerChildId === driver.customerChildId);
    }

    return result;
  }


  // *****************************************************************
  // drivers
  public registerDrivers(drivers: Driver[]): Driver[] {
    drivers.forEach((driver) => {
      let _driver:Driver = this.roadDefendData.driverList.find(_driver_ => _driver_ && _driver_.id === driver.id);
      if (!_driver) {
        this.roadDefendData.driverList.push(driver);
      }
    });

    return this.roadDefendData.driverList;
  }

  public getDriverById(driverId: number): Driver {
     let driver : Driver;
     driver = this.roadDefendData.driverList.find(driver => driver && driver.id === driverId);
     return driver;
  }


  public getAllDrivers(): Driver[] {
    return this.roadDefendData.driverList;
  }

  // *****************************************************************
  // Veiculos
  public registerVehicles(vehicles: Asset[]): Asset[] {
    vehicles.forEach((vehicle) => {
      let _vehicle: Asset = this.roadDefendData.vehicleList.find(_vehicle_ => _vehicle_ && _vehicle_.id === vehicle.id);

      if (!_vehicle) {
        this.roadDefendData.vehicleList.push(vehicle);
      }
    });

    return this.roadDefendData.vehicleList;
  }

  public getAllVehicles(): Asset[] {
    return this.roadDefendData.vehicleList;
  }

  // *****************************************************************
  // Equipamentos
  public registerEquipments(equipments: Equipament[]): Equipament[] {
    equipments.forEach((equipment) => {
      let _equipment: Equipament = this.roadDefendData.equipamentList.find(_equipment_ => _equipment_ && _equipment_.id === equipment.id);
      if(!_equipment) {
        equipment.type = <EquipamentType> equipment.type;
        equipment.status = <Status> equipment.status;
        this.roadDefendData.equipamentList.push(equipment);
      }
    });

    return this.roadDefendData.equipamentList;
  }

  public clearEquipments() {
    this.roadDefendData.equipamentList = new Array<Equipament>();
  }

  public clearDevices() {
    this.roadDefendData.deviceList = new Array<Device>();
  }

  public clearVehicles() {
    this.roadDefendData.vehicleList = [];
  }

  // Listar Equipamento por ID
  public getEquipmentById(equipId: number): Equipament {
    let equipment: Equipament;
    equipment = this.roadDefendData.equipamentList.find((equipment) => equipment.id == equipId);
    return equipment;
  }

  // Listar Todos Equipamentos
  public getAllEquipments(): Equipament[] {
    return this.roadDefendData.equipamentList;
  }

  // *****************************************************************
  // Dispositivos
  public registerDevices(devices: Device[]): Device[] {
    devices.forEach((device) => {
      let _device: Device = this.roadDefendData.deviceList.find(_device_ => _device_ && _device_.id === device.id);
      if(!_device) {
        this.roadDefendData.deviceList.push(device);
      }
    });

    return this.roadDefendData.deviceList;
  }

  public getAllDevices(): Device[] {
    return this.roadDefendData.deviceList;
  }

  // *****************************************************************
  // Ativos
  public getAssetsByIds(assetsIds: number[]){

  }

  // *****************************************************************

  public convertAlarmToAlarmDto(alarm :Alarm) : AlarmDto {
    let _alarmDto: AlarmDto = new AlarmDto();

    _alarmDto = <AlarmDto>Object.assign({}, alarm);

    if (!_alarmDto.driverName) {
          let driver: Driver = this.getDriverById(_alarmDto.driverId);
          if (driver) {
            _alarmDto.driverName = driver.name;
            _alarmDto.driverPicture = driver.picture;
          } else {
            // temporario
            if (_alarmDto.driver_firstname) _alarmDto.driverName = _alarmDto.driver_firstname
            if (_alarmDto.driver_lastname) {
              if (_alarmDto.driverName)
                _alarmDto.driverName += ' ' + _alarmDto.driver_lastname;
              else
                _alarmDto.driverName = _alarmDto.driver_lastname;
            }
          }
    }

    if (_alarmDto.driver_firstname) _alarmDto.driverName = _alarmDto.driver_firstname;
    if (_alarmDto.driver_lastname) _alarmDto.driverName += ' ' + _alarmDto.driver_lastname;


    if (!_alarmDto.assetIdentification) {
        let asset: Asset = this.getAssetById(_alarmDto.assetId);
        if (asset) {
          _alarmDto.assetIdentification = asset.identification;
        } else {
          // temporario
          if (_alarmDto.vehicle_plates) _alarmDto.assetIdentification = _alarmDto.vehicle_plates;
          if (_alarmDto.vehicle_prefix) _alarmDto.assetPrefix = _alarmDto.vehicle_prefix;
        }
    }

    if (_alarmDto.vehicle_plates) _alarmDto.assetIdentification = _alarmDto.vehicle_plates;
    if (_alarmDto.vehicle_prefix) _alarmDto.assetPrefix = _alarmDto.vehicle_prefix;

    if (alarm.alarmRead) {
      _alarmDto.leitura = '<img t src="assets/images/checked-symbol.png" style="margin-left: 18px;" />'
    } else {
      _alarmDto.leitura = '<img t src="assets/images/checked-symbol-not.png" style="margin-left: 18px;" />'
    }

    let typeicon = this.alarmTypesNumber.find((alarme) => alarme.value == _alarmDto.typeAlarm);

    if(typeicon) _alarmDto.alarmTypeIcon = typeicon.icon;

    return _alarmDto;
  }

  public convertInfractionDto(infraction :Infraction) : InfractionDto {
    let _infractionDto: InfractionDto = new InfractionDto();

    _infractionDto = <InfractionDto>Object.assign({}, infraction);

    return _infractionDto;
  }


  public getAllAlarmsDtoByDriver(): AlarmDto[] {
    let _alarms: Array<AlarmDto> = <Array<AlarmDto>>this.roadDefendData.alarmList;

   _alarms.map(
      (alarmDto: AlarmDto)=>{
        let driver: Driver = this.getDriverById(alarmDto.driverId);
        if (driver) {
          alarmDto.driverName = driver.name;
          alarmDto.driverPicture = driver.picture;
        }
        let asset: Asset = this.getAssetById(alarmDto.assetId);
        if (asset) {
          alarmDto.assetIdentification = asset.identification;
          alarmDto.assetPrefix = asset.name;
        }
      });
    return _alarms;
  }

  public getAlarmsByDriverId(driverId: number): Alarm[] {
    return this.roadDefendData.alarmList.filter(alarm => alarm.driverId === driverId)
           .sort((o1,o2)=>{if (o1.id > o2.id) return 1; else if (o1.id < o2.id) return -1; else return 0});
  }

  public getAssetById(assetId : number): Asset {
    return this.roadDefendData.assetList.find(asset => asset && asset.id === assetId);
  }

  public getRoadDefendData(): RoadDefendData {
    return this.roadDefendData;
  }

  public async setPictureAlarm(alarm: Alarm, picture: string, movie?: string) {
    let _alarm: Alarm = this.roadDefendData.filteredAlarmList.find((alarmSalved : Alarm) => alarmSalved.id == alarm.id);

    if(_alarm){
      _alarm.picture = picture;

      if(movie) _alarm.movie = movie;
    }
  }

  public setAlarmList(alarms: Alarm[]): void {
    this.roadDefendData.alarmList = alarms;
  }

  public readyRelatedCam(alarm: Alarm){
    let allAlarms = this.getFilteredAlarmDtoList();

    let allAlarmsFiltered = allAlarms.filter((selectedcam: AlarmDto)=>{
      return selectedcam.driverId == alarm.driverId && selectedcam.typeAlarm == alarm.typeAlarm
    });

    return allAlarmsFiltered;
  }

  /**
  * Registrar no Roadefend os Customers recuperados do REST
  */
  public registerCustomerChilds(customerChilds: CustomerChild[]) {
    customerChilds.forEach((customerChild : CustomerChild) => {
      let _customerChild: CustomerChild;
      _customerChild = this.roadDefendData.customerChildList.find(mcustomerChild => mcustomerChild.id == customerChild.id);

      if(!_customerChild) {
        this.roadDefendData.customerChildList.push(customerChild);
      }
    })
  }

  public clearCustomerChilds(){
    this.roadDefendData.customerChildList = [];
  }

  /**
   * Recupera os Customers já registrados do Roadefend
  */
  public getAllCustomerChilds(): CustomerChild[] {
    let activeCustomerChildren = this.roadDefendData.customerChildList.filter(customerChild => customerChild.status === 1)
    return activeCustomerChildren
  }

  public existsCustomersChild(): boolean {
    return (this.roadDefendData.customerChildList.length > 0)? true : false;
  }

  /**
   * Verifica se o Usuário gravado no Workspace possui, ou não, permissões de Usuário Creare
   */
  verifyIsCreareUser(): boolean {
    const wk: Workspace = this.getWorkspace();
    let findedPermission = wk.accessControlDesc.find((ac : AccessControlDesc) => this.getPermissionRole(ac.permissionDesc) == 'CREARE');

    return findedPermission || wk.isDealer ? true : false;
  }

  verifyPortalPageAccess(): boolean {
    return this.hasPageAccess('PORTAL');
  }

  verifyPortalV3PageAccess(): boolean {
    return this.hasPageAccess('PORTALV3');
  }

  private hasPageAccess(permission: string): boolean {
    const wk = this.getWorkspace();
    if (!wk || !wk.accessControlDesc) {
      return false;
    }
    return wk.accessControlDesc.some(ac => 
      this.normalizePermissionRole(this.getPermissionRole(ac.permissionDesc)) === permission
    );
  }

  public getCustomersIdFromPermissions(): number[] {
    let customersUser:number[] = [];

    this.roadDefendData.workspace.userCustomerChildIds.forEach((customerChildsPermissions : customerChildsPermissions) => {
        customersUser.push(customerChildsPermissions.customer);
    })

    return customersUser;
  }

  /**
   * Por padrao, as permissoes tem a descricao no formato {ROLE}__{NOME}__{LEVEL}
   * retorna somente o nome, mesmo que tenha "_"
   * Exemplo: ROLE_CUSTOMER_CHILD_TOTAL retorna CUSTOMER_CHILD
   */
  getPermissionRole(permissionDesc: string) : string
  {
      let permission_split = permissionDesc.split("_"); 
      return permission_split.filter((txt: string, ind: number) => ind > 0 && ind < permission_split.length-1 ).join("_"); 
  }

  private normalizePermissionRole(permissionRole: string): string {
    return (permissionRole || '').replace(/[\s_-]/g, '').toUpperCase();
  }
}
